<template>
  <div class="product-page">
    <SearchBox />
    <FilterSection :loading="loading" />
    <ProductGrid />
    <div v-if="loading" class="loading-container">
      <i class="fal fa-spinner-third fa-3x fa-spin"></i>
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</template>

<script>
import {
  FETCH_CATEGORIES,
  FETCH_PRODUCTS,
  UPDATE_FILTER_CATEGORY,
} from "../store/constants";
import { mapActions, mapGetters } from "vuex";
import SearchBox from "./components/SearchBox";
import FilterSection from "./components/FilterSection";
import ProductGrid from "./components/ProductGrid";

export default {
  name: "ProductPage",
  components: { ProductGrid, SearchBox, FilterSection },
  props: {
    category: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  created: function () {
    this.initializeProducts();
  },
  methods: {
    ...mapActions({
      fetchProducts: FETCH_PRODUCTS,
      fetchCategories: FETCH_CATEGORIES,
      setFilterCategory: UPDATE_FILTER_CATEGORY,
    }),
    ...mapGetters(["getProducts"]),
    initializeProducts: async function () {
      this.loading = true;
      await Promise.all([this.fetchProducts(true), this.fetchCategories(true)]);
      this.loading = false;
      if (this.category.length > 0) await this.setFilterCategory(this.category);
    },
  },
};
</script>

<style lang="scss" scoped>
.loading-container {
  margin-top: 2rem;
  margin-bottom: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  i {
    color: var(--bs-green);
  }
}
</style>
